import React from 'react';
import './loading-animation.scss';

const LoadingAnimation = ({inline, text, showMask }) => {
	return (
		<div className={`loading-animation${inline ? ' inline-animation' : '' }`}>
			<div className="loading-animation-content">
				<div className="lds-ripple"><div></div><div></div></div>
				{text && <div>{text}</div>}
			</div>
			{ showMask && <div className="loading-animation-mask"></div> }
		</div>
  );
}

export default LoadingAnimation;
